export default __webpack_public_path__ + "static/media/B0005.87751d26.png";